import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CourseProgressStore from '../../stores/CourseProgressStore';

const statusMap = {
    completed: 1,
    enrolled: 0,
};

const sanitise = ({moduleId, status}) => ({
    moduleId,
    status,
    order: (statusMap[status] || 0),
});


class CourseProgressBar extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            progress: [],
            userId: Number(this.props.userId || this.context.auth.identity.id),
        };
    }


    componentDidMount() {
        this.getProgress = this.getProgress.bind(this);
        this.listener = CourseProgressStore.addListener(this.getProgress);
        this.getProgress();
    }

    componentWillUnmount() {
        this.listener.remove();
    }


    render() {

        return (

            <div className="progressBar">
                {this.state.progress.map((module, i) => (
                    <div key={i} className={`segment ${module.status}`}>
                        <a href={(this.props.success ? `/dashboard/course/${this.props.courseId}` : `/dashboard/module/${module.moduleId}`)} />
                    </div>
                ))}
            </div>
        );
    }

    getProgress() {
        let progress = CourseProgressStore.getProgress(this.props.courseId, this.state.userId);
        if (progress !== undefined) {
            this.setState({progress: progress.map(sanitise).sort((a, b) => (b.order - a.order))});
        }
    }


}

CourseProgressBar.propTypes = {
    courseId: PropTypes.number.isRequired,
    userId: PropTypes.number,
    success: PropTypes.bool,
    cancelled: PropTypes.bool
};

CourseProgressBar.defaultProps = () => ({
    success: false,
    cancelled: false,
});

CourseProgressBar.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseProgressBar;

